import React from "react";
import propTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

function AlertDialog({open, handlerClose}) {
  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);

  return (
    <Dialog
      open={open}
      onClose={handlerClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Recolección agendada"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Su recolección se agendo con éxito
        </DialogContentText>

      </DialogContent>
      <DialogActions>
        
        <Button onClick={handlerClose} color="primary" autoFocus>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  trackingNumber: propTypes.string,
  open: propTypes.bool,
  handlerClose: propTypes.func
};
export default AlertDialog;
